import axios from 'axios';
import AppConfig from '../helpers/config';

// Create Axios instance with base config
const apiClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
    // Sourced from the environment (REACT_APP_CMS_API_KEY) rather than being a
    // literal in this file, so it can be rotated without a code change.
    //
    // This is a convention fix, NOT a secrecy one: any credential a browser
    // sends is readable by whoever loads the page. The value previously
    // hardcoded here is in git history and must be treated as compromised —
    // rotate it, and prefer proxying CMS calls through the backend.
    'X-API-KEY': AppConfig.cmsApiKey,
  },
  timeout: 10000, // Optional: timeout after 10 seconds
});

// GET request
export const getCMSRequest = async (endpoint, params = {}) => {
  try {
    const response = await apiClient.get(endpoint, {params});
    return response.data;
  } catch (error) {
    console.error('GET request error:', error);
    throw error;
  }
};

// POST request
export const postCMSRequest = async (endpoint, data = {}) => {
  try {
    const response = await apiClient.post(endpoint, data);
    return response.data;
  } catch (error) {
    console.error('POST request error:', error);
    throw error;
  }
};

// Delete request
export const deleteCMSRequest = async (endpoint, data = {}) => {
  try {
    const response = await apiClient.delete(endpoint, {params: data});
    return response.data;
  } catch (error) {
    console.error('Delete request error:', JSON.stringify(error));
    throw error;
  }
};
